import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { Router } from '@angular/router';

import {
  finalize,
  map,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';

import {
  Observable,
  Subject,
  merge,
  of,
} from 'rxjs';

import { InternetbankAppApplicationException } from '../../../../../common/exceptions/exceptions';
import { FieldOptions } from '../../../../../ui/controls/field.model';
import { SelectItem } from '../../../../../ui/controls/select-field/select-item';
import { CustomFormControl } from '../../../../../ui/custom-reactive-forms/custom-form-control';
import { CustomFormGroup } from '../../../../../ui/custom-reactive-forms/custom-form-group';
import { ServiceSubscrProviderForm } from '../../../../settings/settings.model';
import { SettingsService } from '../../../../settings/settings.service';
import { PaymentWidgetsServiceService } from '../payment-widgets.service';
import { CategoryCharges } from '../shared/charge-item/category-changes';
import { WidgetBaseDirective } from '../shared/widget-base-component';

import { PaymentPayeeItem } from './../payment-widget-data';
import { ChargeForWidget } from './../shared/charge-item/change-item-entites';


@Component({
	selector: 'app-widget-payment-category',
	templateUrl: './widget-payment-category.component.html',
	styleUrls: ['./widget-payment-category.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WidgetPaymentCategoryComponent extends WidgetBaseDirective
	implements OnInit, OnDestroy {

	@Input()
	public categoryId: number;

	@Input()
	public categoryCharges: CategoryCharges | undefined;

	public typeSelectControl: CustomFormControl | null;
	public searchTextControl: CustomFormControl | null;

	private ngUnsubscribe: Subject<void> = new Subject<void>();

	constructor(
		protected override router: Router,
		protected override paymentWidgetsServiceService: PaymentWidgetsServiceService,
		protected override changeDetectorRef: ChangeDetectorRef,
		private settingsService: SettingsService,
	) {
		super(router, paymentWidgetsServiceService, changeDetectorRef);
	}

	public ngOnInit(): void {

		this.updateProperties();

		this.searchForm = new CustomFormGroup({
			typeSelect: new CustomFormControl(
				new FieldOptions({
					'@type': 'select-field',
					name: 'typeSelect',
					hints: {},
				}),
			),
			searchText: new CustomFormControl(
				new FieldOptions({
					'@type': 'text-field',
					name: 'searchText',
					required: true,
					inputMode: 'numeric',
					label: undefined,
					hints: {},
				}),
			),
		});

		this.typeSelectControl = this.searchForm.getControlFromAllLevels(
			'typeSelect',
		);
		this.searchTextControl = this.searchForm.getControlFromAllLevels(
			'searchText',
		);

		this.typeSelectControl?.valueChanges
			.subscribe((x: number) => {
				// switch (x) {
				//     case 1: {
				//         this.searchTextControl.fieldOptions.hints = { underLineHint: '20 или 25 цифр' };
				//         this.searchTextControl.fieldOptions.inputMask = {
				//             mask: '9{20,25}', autoUnmask: false, showMaskOnFocus: true, showMaskOnHover: false,
				//         },
				//             this.searchTextControl.setValidators([
				//                 CustomValidators.uinLength(),
				// 				   CustomValidators.uin(),
				//             ]);
				//         break;
				//     }
				//     case 2: {
				//         this.searchTextControl.fieldOptions.hints = { underLineHint: '12 цифр' };
				//         this.searchTextControl.fieldOptions.inputMask = {
				//             mask: '9{0,12}',
				//             autoUnmask: false,
				//             showMaskOnFocus: false,
				//             showMaskOnHover: false,
				//             placeholder: ''
				//         };
				//         this.searchTextControl.setValidators([
				//             CustomValidators.inn(),
				//             CustomValidators.patternWithMessage(/^.{12}$/, 'Значение должно содержать 12 символов'),
				//             CustomValidators.patternWithMessage(/^[0-9]*$/, 'Введено некорректное значение')
				//         ]);
				//         break;
				//     }
				// }
			});

		merge(
			this.typeSelectControl?.valueChanges || of(undefined),
			this.searchTextControl?.valueChanges || of(undefined),
		)
			.subscribe(() => {
				this.chargeWidget.searcErrors = null;
				this.searchTextControl?.markAsPristine();
				this.charges = [];
			});

		this.typeSelectControl?.onTemplateControlInit
			.subscribe(() => {
				// typeSelectControl.setValue(typeSelectControl.fieldOptions.items[0].value);
			});

		this.typeSelectControl?.valueChanges.pipe()
			.subscribe((payeeId: number) => {
				this.searchTextControl?.setValue(null, {
					onlySelf: true,
					emitEvent: false,
				});

				if (payeeId) {
					this.paymentWidgetsServiceService
						.getPayeeForm(payeeId)
						.subscribe((result: ServiceSubscrProviderForm) => {
							if (this.searchTextControl) {
								this.searchTextControl.fieldOptions.label = result.idFieldLabel;
								this.searchTextControl.fieldOptions.customRegExp = result.customRegExp;
							}
							if (result.customInputMask) {
								if (this.searchTextControl) {
									this.searchTextControl.fieldOptions.inputMask = {
										mask: result.customInputMask.value,
										autoUnmask: true,
										showMaskOnFocus: true,
										showMaskOnHover: false,
									};
								}
							}
							if (result.customRegExp) {
								this.searchTextControl?.addValidator(
									Validators.pattern(result.customRegExp),
								);
							}
							if (result.maxLength && !result.customInputMask) {
								if (this.searchTextControl) {
									this.searchTextControl.fieldOptions.maxLength = result.maxLength;
								}
							}
							if (result.underLineHint) {
								if (this.searchTextControl) {
									this.searchTextControl.fieldOptions.hints = {underLineHint: result.underLineHint};
								}
							}
						});
				}
			});

	}

	public ngOnDestroy(): void {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	public onTabSubscriptionActivate(): void {
		this.paymentWidgetsServiceService
			.getPaymentsAccrualsOnSubscription()
			.pipe(
				tap((data: Array<CategoryCharges>) => {
					if (data) {
						this.categoryCharges = data.find(
							(el: CategoryCharges) => el.id === this.categoryId,
						);
						this.updateProperties();
					}
				}),
				takeUntil(this.ngUnsubscribe),
			)
			.subscribe();
	}

	public onTabSearchActivate(): void {
		this.charges = [];
		if (this.categoryCharges) {
			this.categoryCharges.accruals = [];
		}

		this.paymentWidgetsServiceService
			.getCategoryPayeeList(this.categoryCharges?.id)
			.pipe(
				tap((payeeList: Array<PaymentPayeeItem>) => {
					if (payeeList && payeeList.length) {
						if (this.typeSelectControl) {
							this.typeSelectControl.fieldOptions.items = payeeList.map((item: PaymentPayeeItem) => new SelectItem(item.label, item.id));
						}
						if (this.typeSelectControl?.fieldOptions.hints) {
							this.typeSelectControl.fieldOptions.hints.underLineHint = payeeList[0].underLineHint;
						}
						this.typeSelectControl?.setValue(this.typeSelectControl.fieldOptions.items?.[0].value);
					}
					this.changeUnderlineHint(payeeList);
				}),
				takeUntil(this.ngUnsubscribe),
				finalize(() => {
					this.changeDetectorRef.markForCheck();
				}),
			)
			.subscribe();
	}
	public search(): void {

		this.chargeWidget.searcErrors = null;

		if (this.searchTextControl?.invalid) {
			return;
		}

		this.chargeWidget.startSearch(this.searchTextControl?.value);

		this.searchPaymentsAccrualsOnPayeeForm()
			.pipe(
				takeUntil(this.ngUnsubscribe),
				finalize(() => {
					this.chargeWidget.stopSearch();
					this.changeDetectorRef.markForCheck();
				}),
			)
			.subscribe(
				(data: Array<ChargeForWidget>) => {
					if (data) {
						data.forEach((item: ChargeForWidget) => item.payeeCategoryId = this.categoryId);
					}
					this.charges = data;
				},
				(error: InternetbankAppApplicationException) => {
					this.chargeWidget.searcErrors = error.errors || null;
				},
			);
	}

	public handleKeyDown(event: KeyboardEvent): void {
		if (event.keyCode === 13) {
			// 'enter' pressed
			this.search();
		}
	}

	private changeUnderlineHint(payeeList: Array<PaymentPayeeItem>): void {
		this.typeSelectControl?.valueChanges
			.pipe(
				takeUntil(this.ngUnsubscribe),
			)
			.subscribe((value: number) => {
				if (this.typeSelectControl?.fieldOptions?.hints?.underLineHint) {
					this.typeSelectControl.fieldOptions.hints.underLineHint = payeeList.find((item: PaymentPayeeItem) => item.id === value)?.underLineHint || undefined;
				}
			});
	}

	private searchPaymentsAccrualsOnPayeeForm(): Observable<ChargeForWidget | Array<ChargeForWidget>> {
		if (this.typeSelectControl?.value === SettingsService.GIS_PAYEE_ID) {
			return this.settingsService.validateGis(this.searchTextControl?.value)
				.pipe(
					switchMap(() => this.paymentWidgetsServiceService.searchPaymentsAccrualsGisZkhOnPayeeForm(this.searchTextControl?.value)),
				);
		}
		return this.paymentWidgetsServiceService
			.searchPaymentsAccrualsOnPayeeForm(
				this.typeSelectControl?.value,
				this.searchTextControl?.value,
			)
			.pipe(
				map((data: ChargeForWidget) => (data && [data]) || []),
			);
	}

	private updateProperties(): void {
		if (
			this.categoryCharges &&
			this.categoryCharges.accruals &&
			this.categoryCharges.accruals.length
		) {
			this.categoryCharges.accruals.forEach((x: ChargeForWidget) => {
				x.payeeCategoryId = this.categoryId;
			});
			this.charges = this.categoryCharges.accruals;
		}
		this.subscriptionsAbsence = !!this.categoryCharges?.subscriptionsAbsence;

		this.changeDetectorRef.markForCheck();
	}
}
